import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useHttp } from 'hooks/http.hook';
import { NEWS } from 'endpointsConst';
import Loading from '../../../Loading';
import NewsCard from './NewsCard';
import { getDayMounthYear } from 'helpers/date';
import styles from './styles.module.scss';

const PAGE_LIMIT = 6;

interface NewsItem {
  id: number;
  slug?: string;
  title: string;
  created_at?: string;
  creation_date?: string;
  description?: any;
  preview?: string;
}

const NewsSection: React.FC = () => {
  const { t } = useTranslation();
  const [items, setItems] = useState<NewsItem[]>([]);
  const { request, loading } = useHttp();

  useEffect(() => {
    request(`${NEWS}?limit=${PAGE_LIMIT}`)
      .then((res: any) => {
        setItems(Array.isArray(res?.data?.items) ? res.data.items : []);
      })
      .catch(() => setItems([]));
  }, [request]);

  if (loading) {
    return <Loading />;
  }

  if (items.length === 0) {
    return null;
  }

  return (
    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>{t('main.news.title')}</h2>
      <div className={styles.grid}>
        {items.map((item) => (
          <NewsCard
            key={item.id}
            title={item.title}
            date={getDayMounthYear(item.creation_date || item.created_at)}
            description={item.description}
            imageUrl={item.preview}
            to={`/news/${item.slug || item.id}`}
          />
        ))}
      </div>
      <Link to="/news" className={styles.allNewsButton}>
        {t('main.news.allNews')}
      </Link>
    </section>
  );
};

export default NewsSection;
